// Shared MsgPopup logic for pages that need to:
// - check sys_config.is_have_new_msg
// - fetch sys_get_msg_list
// - show the first unread msg (status === 0)
export default {
  data() {
    return {
      msg: [],
      showNewMsgModal: false,
      newMsgModalData: { name: "", text: "", id: "" },
    };
  },
  methods: {
    openMsgModal(msgItem) {
      this.newMsgModalData = {
        name: (msgItem && msgItem.name) || "New message",
        text: (msgItem && msgItem.text) || "",
        id: (msgItem && msgItem.id) || "",
      };
      this.showNewMsgModal = true;
    },
    getMsgList(options = {}) {
      const { showFirstUnread = false } = options || {};
      return this.$http({
        method: "get",
        url: "sys_get_msg_list",
      }).then((res) => {
        console.debug("msg", res.data);
        this.msg = Array.isArray(res.data) ? res.data : Object.values(res.data || {});

        if (showFirstUnread) {
          const firstUnread = (this.msg || []).find((v) => String(v && v.status) === "0");
          if (firstUnread) this.openMsgModal(firstUnread);
        }

        return this.msg;
      });
    },
    maybeShowFirstUnreadFromBasic(basic) {
      if (basic && basic.is_have_new_msg) {
        return this.getMsgList({ showFirstUnread: true });
      }
      return Promise.resolve([]);
    },
  },
};

